<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :title="disabled ? '详情' : model.pkid > 0 ? '编辑' : '新建'"
      width="1200px"
      class="adaptationModal"
      @close="$reset('form')">
    <el-form
        ref="form"
        v-loading="contentLoading"
        :disabled="disabled"
        :model="model"
        :rules="ruleValidate"
        label-width="120px">
      <div class="editTitle">基本信息</div>
      <el-row>
        <el-col v-if="model.pkid" :span="12">
          <el-form-item label="入库单号" prop="billNo">
            <el-input v-model="model.billNo" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="入库类型" prop="inStockType">
            <el-select v-model="model.inStockType" :disabled="model.pkid > 0" @change="handleTypeChange">
              <el-option label="生产入库" :value="1"/>
              <el-option label="生产退料" :value="4"/>
              <el-option label="客供入库" :value="8"/>
              <el-option label="副产品入库" :value="9"/>
              <el-option label="委外退料" :value="10"/>
              <el-option label="超领退料" :value="11"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col
            v-if="model.inStockType === 1 || model.inStockType === 4 || model.inStockType === 9 || model.inStockType === 11"
            :span="12">
          <el-form-item label="关联单号" prop="relBillNo">
            <el-input v-model="model.relBillNo" placeholder="请输入关联单号" readonly>
              <el-button slot="append" icon="el-icon-search" @click="selectProductionOrder"/>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col v-if="model.inStockType === 8" :span="12">
          <el-form-item label="关联单号" prop="relBillNo">
            <el-input v-model="model.relBillNo" placeholder="请输入客户号" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.customerSelect.open()"/>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col v-if="model.inStockType === 10" :span="12">
          <el-form-item label="关联单号" prop="relBillNo">
            <el-input v-model="model.relBillNo" readonly>
              <el-button slot="append" icon="el-icon-search" @click="$refs.supplierSelect.open()"/>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="备注" prop="note">
            <el-input v-model="model.note" type="textarea" placeholder="请输入" autosize/>
          </el-form-item>
        </el-col>
        <el-col v-if="model.inStockType===4" :span="12">
          <el-form-item label="是否生成领料单">
            <el-radio-group v-model="model.isAddLLD">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>
        <el-col v-if="isPosting" :span="12">
          <el-form-item label="过账时间">
            <el-date-picker
                v-model="model.postTime"
                value-format="yyyy-MM-dd HH:mm:ss"
                type="date"
                placeholder="选择日期"/>
          </el-form-item>
        </el-col>
      </el-row>
      <div v-if="!disabled">
        <el-button
            v-if="model.inStockType === 4 || model.inStockType === 9 || model.inStockType === 11"
            type="primary"
            :disabled="isPosting || !model.relBillNo"
            @click="selectMaterialByFilter">
          添加物料
        </el-button>
        <el-button
            v-else-if="model.inStockType === 8 || model.inStockType === 10"
            type="primary"
            :disabled="isPosting || !model.relBillNo"
            @click="$refs.selectMaterial.open()">
          添加物料
        </el-button>
      </div>
      <div class="editTitle">入库明细</div>
      <el-table :data="model.details">
        <el-table-column
            :label="
              model.inStockType === 1 || model.inStockType === 4 || model.inStockType === 9 || model.inStockType === 11 ? '生产订单' :
              model.inStockType === 8 ? '客户编号' :
              model.inStockType === 10 ? '供应商编号' :
              '订单号'
            ">
          <template slot-scope="scope">
            <span v-if="model.inStockType === 1 || model.inStockType === 4 || model.inStockType === 9 || model.inStockType === 11">
              {{scope.row.productionOrderNo}}
            </span>
            <span v-else-if="model.inStockType === 8">
              {{scope.row.customerNo}}
            </span>
            <span v-else-if="model.inStockType === 10">
              {{scope.row.supplierNo}}
            </span>
            <span v-else>
              {{scope.row.refBillNo}}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="materialNo" label="物料号"/>
        <el-table-column prop="materialName" label="物料名称"/>
        <el-table-column prop="specification" label="规格型号"/>
        <el-table-column prop="warehouseNo" label="库存仓位"/>
        <el-table-column prop="locationNo" label="所属仓位">
          <template slot-scope="scope">
            <el-select
                v-model="scope.row.locationNo"
                placeholder="请选择"
                @change="$set(model.details, scope.$index, scope.row)">
              <el-option
                  v-for="item in constants.locationNo.$options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
              />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column width="170" prop="quantity" label="单据数量">
          <template slot-scope="scope">
            <el-input-number
                v-model="scope.row.quantity"
                :disabled="isPosting"
                style="width: 100%"
                :max="scope.row.maxQuantity !== 0 ? scope.row.maxQuantity || 999999999 : 0"
                @change="quantityHandle(scope.row, scope.$index)"/>
          </template>
        </el-table-column>
        <el-table-column width="170" prop="actualQuantity" label="本次入库数量">
          <template slot-scope="scope">
            <el-input-number
                v-if="scope.row.instockQty>0"
                v-model="scope.row.actualQuantity"
                :disabled="!isPosting"
                style="width: 100%"
                :max="scope.row.quantity-scope.row.instockQty"
                @change="quantityHandle(scope.row, scope.$index)"/>
            <el-input-number
                v-else
                v-model="scope.row.actualQuantity"
                :disabled="!isPosting"
                style="width: 100%"
                :max="scope.row.quantity"
                @change="quantityHandle(scope.row, scope.$index)"/>
          </template>
        </el-table-column>
        <el-table-column prop="instockQty" label="已过账数量"/>
        <el-table-column label="操作" align="center" width="120px">
          <template slot-scope="scope">
            <el-button type="danger" @click="model.details.splice(scope.$index, 1)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-form>
    <span slot="footer">
      <el-button @click="dialogVisible = false">取消</el-button>
      <el-button
          v-if="!isPosting"
          :disabled="disabled"
          :loading="submitLoading"
          type="primary"
          @click="submitHandle">保存</el-button>
      <el-button v-if="isPosting" :loading="submitLoading" type="primary" @click="postToSap">过账</el-button>
    </span>
    <warehouse-select ref="warehouseSelect" @select="warehouseSelect"/>
    <location-select ref="locationSelect" @select="locationSelect"/>
    <production-order-select ref="productionOrderSelect" @select="productionOrderSelect"/>
    <material-select ref="selectMaterial" :is-multi-select="true" @select-change="materialSelect"/>
    <material-select-by-filter ref="selectMaterialByFilter" @select="materialSelectByFilter"/>
    <customer-select ref="customerSelect" @select="customerSelect"/>
    <supplier-select ref="supplierSelect" @select="supplierSelect"/>
  </el-dialog>
</template>

<script>
  import WarehouseSelect from "@/views/information/WarehouseNew/WarehouseSelect";
  import LocationSelect from "./LocationSelect";
  import ProductionOrderSelect from "@/views/ProductionManagement/ProductionOrder/ProductionOrderSelect";
  import MaterialSelect from "@/views/information/Material/MaterialSelect";
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  import constants from "@/util/constants";
  import MaterialSelectByFilter from "@/views/information/Material/MaterialSelectByFilter";
  import SupplierSelect from "@/views/information/SupplierManage/SupplierSelect";

  export default {
    components: {
      SupplierSelect,
      MaterialSelectByFilter,
      CustomerSelect,
      WarehouseSelect,
      LocationSelect,
      ProductionOrderSelect,
      MaterialSelect,
    },
    data() {
      return {
        constants,
        disabled: false,
        isPosting: false,
        dialogVisible: false,
        submitLoading: false,
        contentLoading: false,
        model: {
          pkid: 0,
          billNo: "",
          postTime: "",
          inStockType: "",
          queryType: "",
          relBillNo: "",
          receiptDate: "",
          note: "",
          isAddLLD: true,
          details: [],
        },
        produtctionFilter: {
          billNo: "",
          productionOrderNo: "",
          materialNo: "",
          materialName: "",
          feedingMaterial: true,
          queryType:null,
          isMultiple: false,
        },
        ruleValidate: {
          inStockType: {required: true, message: "入库类型不能为空", trigger: "blur"},
          relBillNo: {required: true, message: "关联单号不能为空", trigger: "blur"},
        },
      };
    },
    methods: {
      open(row, mark, isPosting) {
        this.dialogVisible = true;
        this.disabled = mark;
        this.isPosting = isPosting;
        if (row) {
          this.getData(row.pkid);
        }
      },
      selectProductionOrder() {
        if (this.model.inStockType === 4 || this.model.inStockType === 9 || this.model.inStockType === 11) {//4：生产退料 9：副产品入库 11：超领退料
          this.produtctionFilter.isMultiple=false;
          this.$refs.productionOrderSelect.open(this.produtctionFilter);
        } else { //生产入库
          this.produtctionFilter.queryType=0;
          this.produtctionFilter.isMultiple=true;
          this.$refs.productionOrderSelect.open(this.produtctionFilter);
        }
      },
      getFormatDate(date) {
        let month = date.getMonth() + 1;
        let strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        if (strDate >= 0 && strDate <= 9) {
          strDate = "0" + strDate;
        }
        return date.getFullYear() + "-" + month + "-" + strDate + " 00:00:00";
      },
      getData(pkid) {
        this.contentLoading = true;
        this.$http
          .get("basic", `inStockBills/${pkid}`)
          .then((resp) => {
            if (resp.success) {
              this.model = Object.assign(this.model, resp.data);
              if (this.model.inStockType === 1 || this.model.inStockType === 4 || this.model.inStockType === 8 || this.model.inStockType === 9 || this.model.inStockType === 10 || this.model.inStockType === 11) {
                this.model.details.forEach(item => {
                  if (item.quantity > 0) {
                    item.actualQuantity = item.quantity - item.instockQty;
                  } else {
                    item.actualQuantity = 0 - item.quantity;
                  }
                });
              } else {
                this.model.details.forEach(item => item.actualQuantity = item.instockQty);
              }
              if (this.isPosting) {
                this.model.postTime = this.getFormatDate(new Date());
              }
            }
            this.contentLoading = false;
          })
          .catch(() => {
            this.contentLoading = false;
          });
      },

      quantityHandle(row, index) {
        this.$set(this.model.details, index, row);
      },

      selectWareHouse(row, index) {
        this.currentRow = row;
        this.currentIndex = index;
        this.$refs.warehouseSelect.open();
      },

      selectLocation(row, index) {
        this.currentRow = row;
        this.currentIndex = index;
        this.$refs.locationSelect.open(row.warehouseNo);
      },

      warehouseSelect(row) {
        this.currentRow.locationNo = "";
        this.currentRow.locationName = "";
        this.currentRow.warehouseNo = row.warehouseNo;
        this.currentRow.warehouseName = row.warehouseName;
        this.$set(this.model.details, this.currentIndex, this.currentRow);
      },

      locationSelect(row) {
        this.currentRow.locationNo = row.locationNo;
        this.currentRow.locationName = row.locationName;
        this.$set(this.model.details, this.currentIndex, this.currentRow);
      },

      materialSelectByFilter(row) {
        let quantity = 0;
        console.log(row);
        if (row.length > 0) {
          row.forEach(item => {
            if (this.model.inStockType === 9) {
              quantity = item.requirementNum;
            }
            let obj = {};
            if (this.model.inStockType === 4 || this.model.inStockType === 9 || this.model.inStockType === 11) {
              obj = {
                refBillId: item.mastPKID,
                refBillDetailId: item.pkId,
                refBillNo: item.it,
                productionOrderNo: item.it,
                materialNo: item.materialCode,
                materialName: item.materialDescription,
                quantity: quantity,
                locationNo: item.positionNo,
                unit: item.unit,
                relRowIndex: item.ic,
                reserveOrder:item.rsnum,
                reserveIndex:item.rowIndex,
              };
            } else {
              obj = {
                materialNo: item.materialCode,
                materialName: item.materialDescription,
                quantity: quantity,
                locationNo: item.positionNo,
                unit: item.unit,
                refBillId: item.pkId,
                refBillNo: item.it,
                relRowIndex: item.ic,
                reserveOrder: item.rsnum,
                reserveIndex: item.rowIndex,
              };
            }
            this.model.details.push(obj);
          });
        }
      },
      selectMaterialByFilter() {
        if (this.model.inStockType === 1) {
          this.model.queryType = "生产入库";
        } else if (this.model.inStockType === 4) {
          this.model.queryType = "生产退料";
        } else if (this.model.inStockType === 8) {
          this.model.queryType = "客供入库";
        } else if (this.model.inStockType === 9) {
          this.model.queryType = "副产品入库";
        } else if (this.model.inStockType === 11) {
          this.model.queryType = "超领退料";
        }
        this.$refs.selectMaterialByFilter.open(this.model);
      },

      materialSelect(row) {
        let obj;
        if (this.model.inStockType === 8) {//客供入库
          row.forEach(item => {
            obj = {
              materialId: item.id,
              materialNo: item.no,
              materialName: item.name,
              quantity: 1,
              unit: item.unit,
              customerNo: this.model.relBillNo,
              locationNo: "6102",//默认客供品库存
            };
            this.model.details.push(obj);
          });
        }  else if (this.model.inStockType === 10) {//委外退料
          row.forEach(item => {
            obj = {
              materialId: item.id,
              materialNo: item.no,
              materialName: item.name,
              quantity: 1,
              unit: item.unit,
              supplierNo: this.model.relBillNo,
              purchaseOrder: this.model.relBillNo,
              refBillNo: this.model.relBillNo,
            };
            this.model.details.push(obj);
          });
        }
      },

      customerSelect(row) {
        this.model.relBillNo = row.outerNo;
      },
      supplierSelect(row) {
        this.model.relBillNo = row.no;
      },
      submitHandle() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (!this.model.details.length) {
              this.$confirm("入库明细不能为空", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            const arr = this.model.details.filter((item) => !item.locationNo);
            if (arr.length) {
              this.$confirm("请选择所属仓库", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            // if (this.model.inStockType === 4) {
            //   if (this.model.details.some(item => item.returnType === null || item.returnType === "")) {
            //     this.$confirm("退料类型不能为空！", "错误", {
            //       type: "error",
            //       showCancelButton: false,
            //     });
            //     return;
            //   }
            //   if (this.model.details.some(item => item.actualQuantity - (this.model.pkid > 0 ? item.quantity : 0) > item.originQuantity - item.returnedQuantity)) {
            //     this.$confirm("退料数量不能大于可退数量！", "错误", {
            //       type: "error",
            //       showCancelButton: false,
            //     });
            //     return;
            //   }
            // }
            // this.filter.details.forEach(item => item.quantity = item.actualQuantity);
            this.submitLoading = true;
            this.$http
              .save("basic", "inStockBills", this.model)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  if (this.model.pkid) {
                    this.$emit("save-success");
                    this.$message.success("编辑成功");
                  } else {
                    this.$emit("save-success");
                    this.$message.success("添加成功");
                  }
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      postToSap() {
        this.$refs.form.validate((valid) => {
          if (valid) {
            if (!this.model.details.length) {
              this.$confirm("入库明细不能为空", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            const arr = this.model.details.filter((item) => !item.locationNo);
            if (arr.length) {
              this.$confirm("请选择所属仓库", "错误", {
                type: "error",
                showCancelButton: false,
              });
              return;
            }
            if (this.model.inStockType === 9) {
              console.log(this.model.details);
              if (this.model.details.some(item => item.actualQuantity > (0 - item.quantity))) {
                this.$confirm("本次入库数量不能大于可入数量！", "错误", {
                  type: "error",
                  showCancelButton: false,
                });
                return;

              }
            } else {
              console.log(this.model.details);
              if (this.model.details.some(item => item.actualQuantity > item.quantity)) {
                this.$confirm("本次入库数量不能大于可入数量！", "错误", {
                  type: "error",
                  showCancelButton: false,
                });
                return;
              }
            }
            this.submitLoading = true;
            this.$http
              .post("basic", "inStockBills/postToSap", this.model)
              .then((resp) => {
                this.submitLoading = false;
                if (resp.success) {
                  this.$emit("save-success");
                  this.$message.success("操作成功");
                  this.dialogVisible = false;
                }
              })
              .catch(() => {
                this.submitLoading = false;
                this.$message.error("操作失败");
              });
          }
        });
      },

      handleTypeChange() {
        this.model.relBillNo = "";
        this.model.receiptDate = "";
        this.model.details = [];
      },

      productionOrderSelect(selection) {
        if (this.model.inStockType === 1) {
          const list = [];
          const selectedOrders = selection.map(item => item.orders);
          
          // 检查是否有重复的订单号
          const existingOrders = new Set(this.model.details.map(item => item.productionOrderNo));
          const duplicateOrders = selectedOrders.filter(order => existingOrders.has(order));
          
          if (duplicateOrders.length > 0) {
            this.$confirm(`订单号 ${duplicateOrders.join(", ")} 已存在，不能重复添加！`, "错误", {
              type: "error",
              showCancelButton: false,
            });
          }
          
          const validateOrders = selection.filter(item => !existingOrders.has(item.orders));
          validateOrders.forEach(item => {
            list.push({
              materialNo: item.materialNo,
              refBillId: item.id,
              refBillNo: item.orders,
              productionOrderNo: item.orders,
              relRowIndex: item.sapSalesOrderRowIndex,
              reserveOrder: item.reserveOrder,
              reserveIndex: item.reserveIndex,
              materialName: item.materialDescription,
              locationNo: item.warehouse,
              quantity: item.confirmQty - item.instockQty-item.instockBillNum,
              maxQuantity: item.confirmQty - item.instockQty-item.instockBillNum,
              conQty: item.confirmQty,
              insQty: item.instockQty,
            });
          });

          // 检查是否有入库数量超出报工数量的情况
          const errorItems = list.filter((item) => item.maxQuantity < 0);
          
          if (errorItems.length > 0) {
            // 生成具体的错误信息
            const errorMessages = errorItems.map((item) => {
              const errorIndex = list.indexOf(item) + 1;
              return `第${errorIndex}条已入库数量${item.insQty}已超出报工数量${item.conQty}，请检查！`;
            });
            
            this.$confirm(errorMessages.join("\t"), "错误", {
              type: "error",
              showCancelButton: false,
            });
            return;
          }
          this.model.details.push(...list);
        }
        // 累加关联订单号
        const newOrders = selection.map(item => item.orders);
        if (this.model.relBillNo) {
          const existingOrders = new Set(this.model.relBillNo.split(","));
          const uniqueNewOrders = newOrders.filter(order => !existingOrders.has(order));
          if (uniqueNewOrders.length > 0) {
            this.model.relBillNo = [...existingOrders, ...uniqueNewOrders].join(",");
          }
        } else {
          this.model.relBillNo = newOrders.join(",");
        }
        // this.filter.details = [];
        // if (this.filter.inStockType === 4) {
        //   //退料入库
        //   let param = {
        //     relBillId: row.pkid,
        //   };
        //   this.$http
        //     .get("basic", "outStockBills/returnMaterial", param)
        //     .then((resp) => {
        //       if (resp.success) {
        //         this.filter.relBillId = row.pkid;
        //         this.filter.relBillNo = row.billNo;
        //         this.filter.workCenterId = row.workCenterId;
        //         resp.data.forEach(item => {
        //           item.originQuantity = item.quantity;
        //           item.actualQuantity = item.quantity - item.returnedQuantity;
        //           item.outStockId = item.masterId;
        //           item.outStockRowIndex = item.rowIndex;
        //           this.filter.details.push(item);
        //         });
        //       }
        //     });
        // }
      },
    },
  };
</script>
